import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { billingAPI, storeAPI } from '../services/api';
import { CheckCircle, Loader } from 'lucide-react';

export const Success = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get('session_id');
  const [loading, setLoading] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    }
  }, [sessionId]);

  const checkPaymentStatus = async () => {
    try {
      // Try billing first, then store
      let response;
      try {
        response = await billingAPI.getCheckoutStatus(sessionId);
      } catch {
        response = await storeAPI.getCheckoutStatus(sessionId);
      }

      if (response.data.status === 'paid' || response.data.payment_status === 'paid') {
        setPaymentStatus('success');
        setLoading(false);
      } else if (attempts < 5) {
        // Poll up to 5 times
        setAttempts(attempts + 1);
        setTimeout(checkPaymentStatus, 2000);
      } else {
        setPaymentStatus('pending');
        setLoading(false);
      }
    } catch (error) {
      console.error('Payment status check failed:', error);
      setPaymentStatus('error');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F2EB] flex items-center justify-center py-12 px-4" data-testid="success-page">
      <div className="max-w-md w-full bg-white rounded-2xl p-8 card-soft text-center">
        {loading ? (
          <>
            <Loader className="w-16 h-16 text-[#7C9A92] mx-auto mb-4 animate-spin" />
            <h2 className="text-2xl font-bold text-[#2D3A3A] mb-2" style={{ fontFamily: 'Nunito, sans-serif' }}>
              Processing Payment...
            </h2>
            <p className="text-[#6B7C7C]">Please wait while we confirm your payment</p>
          </>
        ) : paymentStatus === 'success' ? (
          <>
            <CheckCircle className="w-16 h-16 text-[#8FB339] mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-[#2D3A3A] mb-2" style={{ fontFamily: 'Nunito, sans-serif' }}>
              Payment Successful!
            </h2>
            <p className="text-[#6B7C7C] mb-6">Thank you for your purchase. Your transaction has been completed successfully.</p>
            <button
              onClick={() => navigate('/dashboard')}
              className="px-8 py-3 rounded-full bg-[#7C9A92] text-white font-semibold hover:bg-[#6B8A82]"
              data-testid="return-to-dashboard"
            >
              Return to Dashboard
            </button>
          </>
        ) : (
          <>
            <div className="w-16 h-16 rounded-full bg-[#E0C079]/10 flex items-center justify-center mx-auto mb-4">
              <span className="text-3xl">⏱️</span>
            </div>
            <h2 className="text-2xl font-bold text-[#2D3A3A] mb-2" style={{ fontFamily: 'Nunito, sans-serif' }}>
              Payment Pending
            </h2>
            <p className="text-[#6B7C7C] mb-6">Your payment is being processed. Check your email for confirmation.</p>
            <button
              onClick={() => navigate('/dashboard')}
              className="px-8 py-3 rounded-full bg-[#7C9A92] text-white font-semibold hover:bg-[#6B8A82]"
            >
              Return to Dashboard
            </button>
          </>
        )}
      </div>
    </div>
  );
};